import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { RouteName } from '../../routeNames'
import { ActiveTask } from '../Task/ActiveTask'
import { AnsweredTask } from '../Task/AnsweredTask'
import { AnsweredTasks } from '../Task/AnsweredTasks'
import { Dashboard } from './Dashboard'

const Stack = createNativeStackNavigator()

export function Home() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }} initialRouteName={RouteName.Dashboard}>
      <Stack.Screen name={RouteName.Dashboard} component={Dashboard} />
      <Stack.Screen name={RouteName.ActiveTask} component={ActiveTask} />
      <Stack.Screen name={RouteName.AnsweredTasks} component={AnsweredTasks} />
      <Stack.Screen name={RouteName.AnsweredTask} component={AnsweredTask} />
    </Stack.Navigator>
  )
}
